import React from "react";
import { useModals } from "react-easy-modals";
import CategoriesNavigationModal from "@/components/categories-navigation-modal";

const AskServiceContext = React.createContext(null);

const AskServiceProvider = ({ children }) => {
  const modals = useModals();

  const handleShow = (data = {}) => {
    modals.open(CategoriesNavigationModal, {
      url_params: data?.urlParams,
      user: data?.user,
      subcategories: data?.subcategories,
      category_id: data?.id,
    });
  };

  return (
    <AskServiceContext.Provider value={{ show: handleShow }}>{children}</AskServiceContext.Provider>
  );
};

export { AskServiceContext };
export default AskServiceProvider;
